import React, {useCallback, useRef} from 'react';
import Style from './index.module.scss';
import {Schema} from 'form-render/lib/type';
import FormRender, {useForm} from 'form-render';
import {Button, Col, message, Row, Skeleton, Spin} from 'antd';
import useRequestFn from '../../../../../../Utils/Hooks/useRequestFn';
import {
    getTenantTheme,
    saveTenantTheme,
    SaveTenantThemeProp,
    ThemeForm,
} from '../../../service';
import {errorMessage} from '../../../../../../Utils/common';
import {FlexBox} from '../../../../../../Components/FlexBox';
import useRequest from 'Utils/Hooks/useRequest';
import {UploadSinglePhoto} from 'Features/Upload/UploadSinglePhoto';
import _ from 'lodash-es';
import MobileView from '../../../../../../Components/MobileView';
import ColorPick from '../../../../../../Components/FormComponents/ColorPick';
import {useToggle} from 'react-use';

const viewURl = process.env['REACT_APP_PREVIEW_URL'];
interface Props {
    id: string;
    current: number;
    setCurrent: (v: number) => void;
}

interface TypeItem {
    target: 'css' | 'imgUrl';
    key: string;
    value: string;
}
interface MsgType {
    type: 'SET_VALUE';
    data: TypeItem[];
}

const Index = ({id, current, setCurrent}: Props) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const form = useForm();
    const schema: Schema = {
        type: 'object',
        displayType: 'row',
        labelCol: 8,
        fieldCol: 11,
        properties: {
            themeColor: {
                title: '主题色选择',
                required: true,
                type: 'string',
                widget: 'ColorPick',
            },
            fontColor: {
                title: '标题颜色选择',
                required: true,
                type: 'string',
                widget: 'ColorPick',
            },
            subjectLogo: {
                title: 'logo',
                type: 'string',
                widget: 'UploadSinglePhoto',
            },
            backgroundImage: {
                title: '背景图',
                type: 'string',
                widget: 'UploadSinglePhoto',
            },
        },
    };

    const [save, {loading: saveLoading}] = useRequestFn(saveTenantTheme);
    async function onFinish(formData: ThemeForm) {
        try {
            const params: SaveTenantThemeProp = {
                customerId: id,
                paramValue: formData,
                themeId: defaultData?.themeId!,
            };
            return await save(params);
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const [loading, setLoading] = useToggle(true);

    const [defaultData, {loading: getLoading}] = useRequest(
        async () => {
            const res = await getTenantTheme(id);
            setTimeout(() => {
                debounceFn([
                    {
                        key: '--theme-color',
                        value: res.paramValue.themeColor,
                        target: 'css',
                    },
                    {
                        key: '--theme-font-color',
                        value: res.paramValue.fontColor,
                        target: 'css',
                    },
                    {
                        key: '--theme-background-image',
                        value: res.paramValue.backgroundImage,
                        target: 'imgUrl',
                    },
                    {
                        key: '--theme-logo-image',
                        value: res.paramValue.subjectLogo,
                        target: 'imgUrl',
                    },
                ]);
                setLoading(false);
            }, 3000);
            return res;
        },
        {},
        [id],
    );

    async function addStep(step: number) {
        form.validateFields().then(async res => {
            await onFinish(res);
            message.success('保存成功');
            setCurrent(current + step);
        });
    }

    function handleDebounceFn(data: TypeItem[]) {
        const o: MsgType = {data, type: 'SET_VALUE'};
        iframeRef?.current?.contentWindow?.postMessage(o, '*');
    }
    const debounceFn = useCallback(_.debounce(handleDebounceFn, 1000), []);

    const watch = {
        themeColor: (value: string) => {
            debounceFn([{key: '--theme-color', value, target: 'css'}]);
        },
        fontColor: (value: string) => {
            debounceFn([{key: '--theme-font-color', value, target: 'css'}]);
        },
        backgroundImage: (value: string) => {
            debounceFn([
                {
                    key: '--theme-background-image',
                    value,
                    target: 'imgUrl',
                },
            ]);
        },
        subjectLogo: (value: string) => {
            debounceFn([{key: '--theme-logo-image', value, target: 'imgUrl'}]);
        },
    };

    return (
        <div className={Style.root}>
            <Skeleton active loading={getLoading} paragraph={{rows: 10}}>
                <Row style={{marginBottom: 30}}>
                    <Col span={12}>
                        <Spin spinning={loading} tip="预览器载入中，请稍等">
                            <MobileView refs={iframeRef} src={viewURl} />
                        </Spin>
                    </Col>
                    <Col span={12}>
                        <Spin spinning={saveLoading}>
                            <FormRender
                                watch={watch}
                                widgets={{UploadSinglePhoto, ColorPick}}
                                initialValues={defaultData?.paramValue}
                                form={form}
                                schema={schema}
                            />
                            <FlexBox justifyContent="center" gap="15px">
                                <Button onClick={() => addStep(-1)}>
                                    上一步
                                </Button>
                                <Button
                                    onClick={() => addStep(1)}
                                    type="primary">
                                    下一步
                                </Button>
                                {id && (
                                    <Button
                                        onClick={() => addStep(0)}
                                        type="primary">
                                        保存
                                    </Button>
                                )}
                            </FlexBox>
                        </Spin>
                    </Col>
                </Row>
            </Skeleton>
        </div>
    );
};

export default Index;
